import Header from 'application/presentation/common/Header/Header'
import React, { useMemo } from 'react'
import { ReactComponent as DashedCircle } from 'images/icons/dashed_circle.svg'
import { useAppSelector } from 'application/core/domain/store/hooks'
import { useOrdersHistory } from 'application/core/domain/useCase/orders/getOrders'
import { Button, Loader } from 'application/presentation/common/uiComponents'
import stickerImg from 'images/sticker.png'

import s from './FreeWashPage.module.scss'

const defaultWash = {
  image: '',
  order_id: 0,
}

const FreeCoffePage = () => {
  const token = useAppSelector(({ userReducer }) => userReducer.token)
  const { freeCup: freeCupData, isLoading } = useOrdersHistory(token || '')

  const freeCup = freeCupData || freeCupData === 0 ? freeCupData : 5

  const data = useMemo(() => {
    let arr: any = []
    const leftCup = 5 - freeCup
    for (let i = 0; i < 5; i++) {
      if (i < leftCup) {
        arr.push(defaultWash)
      } else {
        arr.push(undefined)
      }
    }
    return arr
  }, [freeCup])

  return (
    <div className={s.container}>
      <Header title="Мойка бесплатно" />
      {isLoading ? (
        <Loader size={32} />
      ) : (
        <div className={s.content}>
          <div className={s.txt}>
            Заполняйте стикеры с логтипом MOY:
            <br />
            при бронировании указывайте свой номер телефона и получите мойку бесплатно!
          </div>

          <div className={s.coffe_container}>
            <div className={s.title}>Осталось еще {freeCup} мойки до бесплатной</div>
            <div className={s.subtitle}>
              Заполняйте стикеры c логотипом MOY: при бронировании указывайте свой номер телефона и
              получите мойку бесплатно!
            </div>

            <div className={s.coffe_list}>
              {data.map((item: any, i: number) => {
                return (
                  <div className={s.coffet_item_container}>
                    <div className={s.coffe_item} key={`free_coffe_${i}`}>
                      <div className={s.dashed_circle}>
                        <DashedCircle />
                      </div>
                      {item ? (
                        <>
                          <div className={s.item_img_container}>
                            <img src={stickerImg} alt="" className={s.item_img} />
                          </div>
                          <div className={s.check}>
                            <span>{i + 1}</span>
                          </div>
                        </>
                      ) : (
                        <div className={s.mumber_block}>{i + 1}</div>
                      )}
                    </div>
                  </div>
                )
              })}
              <div className={s.coffet_item_container}>
                <div className={`${s.coffe_item} ${s.last}`}>
                  <div className={s.last_txt}>Бесплатная мойка</div>
                </div>
              </div>
            </div>
            <Button
              color="fiol_border"
              text={'История моек'}
              isLink
              to="/orders"
              containerClassName={s.btn}
            />
          </div>
          <div className={s.rules}>
            Подробные правила акции описаны в пользовательском соглашении. <a href="#">Подробнее</a>
          </div>
        </div>
      )}
    </div>
  )
}

export default React.memo(FreeCoffePage)
